/**
 * @flow
 * @relayHash 043ed29a0ebb0665dd17c0966b466558
 */

/* eslint-disable */

'use strict'

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RewardsDeletePromotionInput = {|
  slug: string,
  clientMutationId?: ?string,
|};
export type PromoContainerDeletePromoMutationVariables = {|
  input: RewardsDeletePromotionInput
|};
export type PromoContainerDeletePromoMutationResponse = {|
  +rewardsDeletePromotion: ?{|
    +success: ?boolean,
    +errors: ?$ReadOnlyArray<?{|
      +statusCode: ?number,
      +message: ?string,
      +meta: ?any,
      +errorCode: ?string,
      +code: ?number,
    |}>,
  |}
|};
export type PromoContainerDeletePromoMutation = {|
  variables: PromoContainerDeletePromoMutationVariables,
  response: PromoContainerDeletePromoMutationResponse,
|};
*/

/*
mutation PromoContainerDeletePromoMutation(
  $input: RewardsDeletePromotionInput!
) {
  rewardsDeletePromotion(input: $input) {
    success
    errors {
      statusCode
      message
      meta
      errorCode
      code
    }
  }
}
*/

const node /*: ConcreteRequest*/ = (function() {
    var v0 = [
            {
                kind: 'LocalArgument',
                name: 'input',
                type: 'RewardsDeletePromotionInput!',
                defaultValue: null,
            },
        ],
        v1 = [
            {
                kind: 'LinkedField',
                alias: null,
                name: 'rewardsDeletePromotion',
                storageKey: null,
                args: [
                    {
                        kind: 'Variable',
                        name: 'input',
                        variableName: 'input',
                    },
                ],
                concreteType: 'RewardsDeletePromotionPayload',
                plural: false,
                selections: [
                    {
                        kind: 'ScalarField',
                        alias: null,
                        name: 'success',
                        args: null,
                        storageKey: null,
                    },
                    {
                        kind: 'LinkedField',
                        alias: null,
                        name: 'errors',
                        storageKey: null,
                        args: null,
                        concreteType: 'RewardsError',
                        plural: true,
                        selections: [
                            {
                                kind: 'ScalarField',
                                alias: null,
                                name: 'statusCode',
                                args: null,
                                storageKey: null,
                            },
                            {
                                kind: 'ScalarField',
                                alias: null,
                                name: 'message',
                                args: null,
                                storageKey: null,
                            },
                            {
                                kind: 'ScalarField',
                                alias: null,
                                name: 'meta',
                                args: null,
                                storageKey: null,
                            },
                            {
                                kind: 'ScalarField',
                                alias: null,
                                name: 'errorCode',
                                args: null,
                                storageKey: null,
                            },
                            {
                                kind: 'ScalarField',
                                alias: null,
                                name: 'code',
                                args: null,
                                storageKey: null,
                            },
                        ],
                    },
                ],
            },
        ]
    return {
        kind: 'Request',
        fragment: {
            kind: 'Fragment',
            name: 'PromoContainerDeletePromoMutation',
            type: 'Mutation',
            metadata: null,
            argumentDefinitions: (v0 /*: any*/),
            selections: (v1 /*: any*/),
        },
        operation: {
            kind: 'Operation',
            name: 'PromoContainerDeletePromoMutation',
            argumentDefinitions: (v0 /*: any*/),
            selections: (v1 /*: any*/),
        },
        params: {
            operationKind: 'mutation',
            name: 'PromoContainerDeletePromoMutation',
            id: null,
            text:
                'mutation PromoContainerDeletePromoMutation(\n  $input: RewardsDeletePromotionInput!\n) {\n  rewardsDeletePromotion(input: $input) {\n    success\n    errors {\n      statusCode\n      message\n      meta\n      errorCode\n      code\n    }\n  }\n}\n',
            metadata: {},
        },
    }
})()
// prettier-ignore
;(node/*: any*/).hash = '9671d44228b46c0166886366f44d231b';
module.exports = node
